import {
  useMutation,
  useQueryClient,
  UseMutationOptions,
} from "@tanstack/react-query";
import authorApiClient from "../../api/author";

type FeaturedArtistMutationOptions = Omit<
  UseMutationOptions<void, Error, string, unknown>,
  "mutationKey" | "mutationFn"
>;

const useFeaturedArtistMutation = (options?: FeaturedArtistMutationOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["toggle-artist-featured"],
    mutationFn: (artistId: string) => authorApiClient.toggleFeatured(artistId),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ["artists"] });
      options?.onSuccess?.(...args);
    },
    ...options,
  });
};

export default useFeaturedArtistMutation;
